import { defineModule } from '@portal/kernel';

export const manifest = defineModule({
  key: 'core-identity',
  version: '0.1.0',
  kind: 'core',
  coreVersion: '^0.1.0',
  name: { vi: 'Tài khoản & Đăng nhập', en: 'Identity' },
  description: {
    vi: 'Đăng nhập Google Workspace, tài khoản người dùng, phiên đăng nhập, domain được phép.',
    en: 'Google Workspace sign-in, user accounts, sessions, allowed domains.',
  },
  dependsOn: ['core-system', 'core-audit'],
  database: { schema: 'core_identity' },
  permissions: [
    { key: 'core-identity.user.view', name: { vi: 'Xem danh sách người dùng', en: 'View users' } },
    {
      key: 'core-identity.user.manage',
      name: { vi: 'Mời, duyệt, khoá người dùng', en: 'Invite, approve and suspend users' },
    },
    {
      key: 'core-identity.domain.manage',
      name: { vi: 'Quản lý domain được phép đăng nhập', en: 'Manage allowed sign-in domains' },
    },
  ],
  navigation: [
    {
      id: 'admin.users',
      parent: 'admin',
      label: { vi: 'Người dùng', en: 'Users' },
      icon: 'users',
      path: '/admin/users',
      permission: 'core-identity.user.view',
      order: 5,
    },
  ],
});
